import React from 'react';
import {connect} from 'react-redux';
import {Redirect} from 'react-router';
import styled from 'styled-components';

import {pxToEm} from '../../components/globalStyles';
import ScrollToTopOnMount from '../../components/layout/scrollToTopOnMount';
import {AppRoutePathFunction} from '../../logic/routes';
import {RootState} from '../../logic/store';
import * as AuthenticationStore from '../../logic/store/authenticationStore';
import {AuthenticationStatus, State as AuthenticationState} from '../../logic/store/authenticationStore';
import {ThunkDispatch} from '../../logic/store/redux-thunk';
import BitmovinLogoSvg from '../../media/bitmovin_logo.svg';

import LoginForm from './loginForm';

//#region Styled Components

const StyledWrapperDiv = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
  background: linear-gradient(302.84deg, #cbe0ed -0.94%, #eef6f9 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledBitmovinLogoImg = styled.img`
  margin-top: ${pxToEm(87)}em;
  margin-bottom: ${pxToEm(74)}em;
  height: ${pxToEm(42)}em;
`;

const headerFontSizePx = 34;
const StyledHeader = styled.h1`
  font-size: ${pxToEm(headerFontSizePx)}em;
  margin: 0 0 ${pxToEm(74) / pxToEm(headerFontSizePx)}em;
`;

const StyledStretchDiv = styled.div`
  flex-grow: 1;
`;

//#endregion

interface MapStateToProps {
  authenticationState: AuthenticationState;
}

interface MapDispatchToProps {
  login: (username: string, password: string) => void;
}

interface Props extends MapStateToProps, MapDispatchToProps {}

class LoginPageView extends React.Component<Props> {
  private handleLoginFormSubmit = (username: string, password: string) => {
    this.props.login(username, password);
  };

  public render() {
    const {authenticationState} = this.props;
    const skipLoginPageView =
      authenticationState.status === AuthenticationStatus.LoggedIn ||
      authenticationState.status === AuthenticationStatus.Offline;

    return (
      <StyledWrapperDiv>
        {skipLoginPageView && <Redirect to={AppRoutePathFunction.Root()} />}

        <StyledBitmovinLogoImg src={BitmovinLogoSvg} alt="BitmovinLogoSvg" />
        <StyledHeader>Sales Demos</StyledHeader>
        <LoginForm authStatus={authenticationState.status} onSubmit={this.handleLoginFormSubmit} />
        <StyledStretchDiv />

        <ScrollToTopOnMount />
      </StyledWrapperDiv>
    );
  }
}

const mapStateToProps = (state: RootState): MapStateToProps => ({
  authenticationState: state.authentication
});

const mapDispatchToProps = (dispatch: ThunkDispatch): MapDispatchToProps => {
  return {
    login: (username: string, password: string) => dispatch(AuthenticationStore.login(username, password))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginPageView);
